/** Tool names with a documented multi-second-to-multi-minute wait — deploy_website/
 *  merge_website_branch poll a real external build; map_website_content/identify_website_stack
 *  run a full agentic research pass. A bare spinner with unchanging text for over a minute reads
 *  as a hung request; naming the expected wait up front heads that off. Shared by
 *  BagelThinkingIndicator and ThinkingPill so the list can't drift out of sync between them. */
export const SLOW_THINKING_TOOLS = new Set([
  'deploy_website',
  'merge_website_branch',
  'map_website_content',
  'identify_website_stack',
]);

export const SLOW_TOOL_HINT_THRESHOLD_SECONDS = 15;
